import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { components, useServices, useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import UsProductMasterKeys from '../../../constants/locale/key/UsProductMaster'
import UsProductMasterApiUrls from '../../../apiUrls/UsProductMasterApiUrls'
import pathMap from '../../../paths/pathMap'
import ProductMasterLookupsProvider from '../lookups/ProductMasterLookupsContext'
import ProductMasterViewContent from './ProductMasterViewContent'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider,
  Grid
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton }
} = components

function ViewPage(props) {
  const { history, showNotification } = props
  const { id } = useParams()
  const [data, setData] = useState(null)
  const [confirmDialog, setConfirmDialog] = useState(false)
  const { createRecord, deleteRecord, fetchRecord } = useServices()
  const { translate } = useTranslation(Namespace.US_PRODUCT_MASTER)

  useEffect(() => {
    fetchRecord.execute(UsProductMasterApiUrls.GET, id, (res) => {
      const data = res.content[0]

      if (data === undefined) {
        showNotification('error', 'Data not found.')
        history.push(pathMap.US_PRODUCT_MASTER_LIST_VIEW)
      } else {
        setData(data)
      }
    })
  }, [])

  if (!data) {
    return (
      <Grid container justify='center'>
        <Grid item xs='auto'>
          <CircularProgress />
        </Grid>
      </Grid>
    )
  }

  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    const cloneButton = translate(
      Namespace.US_PRODUCT_MASTER,
      UsProductMasterKeys.CLONE_BUTTON
    )

    return { cloneButton }
  }

  function handleCloneProduct() {
    createRecord.execute(UsProductMasterApiUrls.CLONE, data, (data) =>
      history.push(pathMap.US_PRODUCT_MASTER_ADD_VIEW, data)
    )
  }

  function handleDeleteProduct() {
    deleteRecord.execute(UsProductMasterApiUrls.DELETE, data, () => {
      showNotification('success', 'Delete succeeded')
      history.push(pathMap.US_PRODUCT_MASTER_LIST_VIEW)
    })
  }

  return (
    <>
      <Card>
        <CardContent>
          <ProductMasterLookupsProvider>
            <ProductMasterViewContent
              data={data}
              history={history}
              showNotification={showNotification}
            />
          </ProductMasterLookupsProvider>
        </CardContent>
        <Divider />
        <CardActions style={{ padding: 16, justifyContent: 'space-between' }}>
          <CngButton
            color='secondary'
            onClick={() => history.push(pathMap.US_PRODUCT_MASTER_LIST_VIEW)}
          >
            Back to product master list
          </CngButton>
          <Box display='flex' style={{ gap: 16 }}>
            <CngButton
              color='secondary'
              onClick={() => setConfirmDialog(true)}
              startIcon={<FontAwesomeIcon icon={['fal', 'trash']} size='sm' />}
            >
              Delete
            </CngButton>
            <CngButton
              color='secondary'
              onClick={handleCloneProduct}
              startIcon={<FontAwesomeIcon icon={['fal', 'copy']} size='sm' />}
            >
              {translatedTextsObject.cloneButton}
            </CngButton>
            <CngButton
              startIcon={<FontAwesomeIcon icon={['fal', 'pen']} size='sm' />}
              onClick={() =>
                history.push(`${pathMap.US_PRODUCT_MASTER}/edit/${id}`)
              }
            >
              Edit
            </CngButton>
          </Box>
        </CardActions>
      </Card>
      <AlertDialog
        cancelLabel='No, take me back'
        confirmLabel='Yes, delete'
        open={confirmDialog}
        onClose={() => setConfirmDialog(false)}
        onCancel={() => setConfirmDialog(false)}
        onConfirm={handleDeleteProduct}
        title='Delete'
      >
        Items that you delete can't be restored. Are you sure about this?
      </AlertDialog>
    </>
  )
}

export default ViewPage
